import { BEIGE_1000, BEIGE_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'

import { FC } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined'
import { useTranslation } from 'react-i18next'

/**
 * "Thank you for your feedback!" step shown after successful rating submission.
 * Uses a warm handshake/heart icon to match the Figma design.
 *
 * @example
 * <StarRatingThankYou />
 */
export const StarRatingThankYou: FC = () => {
  const { t } = useTranslation(['star_rating'])

  return (
    <Stack alignItems="center" justifyContent="center" gap="1.6rem" padding="4rem 2rem">

      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '6.4rem',
          height: '6.4rem',
          borderRadius: '50%',
          backgroundColor: BEIGE_600
        }}
      >
        <VolunteerActivismOutlinedIcon sx={{ fontSize: '3.2rem', color: BEIGE_1000 }} />
      </Stack>

      <Typography variant="text-2xl" fontWeight={600} color={GRAY_900}>
        {t('star_rating:thank_you_title')}
      </Typography>

      <Typography variant="text-sm" color={GRAY_700} textAlign="center">
        {t('star_rating:thank_you_subtitle')}
      </Typography>

    </Stack>
  )
}
